export type JourneyStepEmailTestingStatus = "not_started" | "in_progress" | "completed";

export type JourneyStepEmailTesting = {
  status: JourneyStepEmailTestingStatus;
  last_test_to?: string;
  commenced_at?: string;
  completed_at?: string;
};

export function readJourneyStepEmailTesting(step: Record<string, unknown>): JourneyStepEmailTesting {
  const raw = step.email_testing as JourneyStepEmailTesting | undefined;
  if (!raw?.status) return { status: "not_started" };
  return raw;
}

export function isJourneyStepTestCommenced(step: Record<string, unknown>): boolean {
  const { status } = readJourneyStepEmailTesting(step);
  return status === "in_progress" || status === "completed";
}

export function isJourneyStepTestCompleted(step: Record<string, unknown>): boolean {
  return readJourneyStepEmailTesting(step).status === "completed";
}
